var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 115,
    height: 56,
    fill: "none",
    viewBox: "0 0 115 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2E85EF",
    d: "M93.653 0H21.287l-2.41 1.008v2.731l2.077 1.623a1.955 1.955 0 0 1 .625 1.441l5.04 15.643c.08 1.451.866 2.6 1.803 2.6h58.256c.938 0 1.724-1.149 1.794-2.6l5.04-15.633a2.015 2.015 0 0 1 .615-1.43l2.015-1.644V1.008L93.652 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F3251",
    d: "M89.238 4.032H20.78l-1.63 1.922v3.062l2.08 2.063c.197.23.354.509.463.82.108.31.165.647.168.987L19.68 26.982c.08 1.807.86 3.255 1.8 3.255H92.89c.94 0 1.72-1.448 1.79-3.255l-1.54-14.096c0-.338.053-.674.158-.984.105-.311.259-.591.452-.823l2-2.063V5.954l-6.511-1.922z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#143C6D",
    d: "M92.726 29.229h-71.56v6.047h71.56V29.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#164E93",
    d: "M23.655 7.015l-5.16 8.174 4.132 15.29 1.391 1.975 1.684-3.225-2.047-22.214zM90.972 7.015l5.17 8.174L92 30.479l-1.39 1.975-1.916-3.73 2.278-21.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E85EF",
    d: "M94.217 13.355s1.673 1.461 1.643 2.015L91.385 29.3c-.06 1.29-.766 2.317-1.602 2.317h-65.17c-.837 0-1.542-1.007-1.613-2.318L18.515 15.36c0-.554 1.582-2.015 1.582-2.015l-.08-1.946H4.032v7.489l2.892 2.278a2.702 2.702 0 0 1 .867 2.015l7.055 21.106c.101 2.015 1.2 3.628 2.5 3.628h80.42c1.31 0 2.388-1.602 2.499-3.628l6.994-21.105a2.788 2.788 0 0 1 .857-2.016l2.842-2.288v-7.469h-16.56l-.18 1.946z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M93.653 0H21.287c-.101.06-2.41 1.008-2.41 1.008h77.235S93.734.12 93.652 0z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B1C30",
    d: "M29.128 4.485h56.764a1.49 1.49 0 0 1 .282-.171l1.603-.645H27.213l1.633.635c.11.032.207.095.282.181z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M4.102 19.009l2.862 2.267a2.73 2.73 0 0 1 .847 2.016l7.005 21.055c.1 2.016 1.19 3.538 2.49 3.538h4.726l-2.015-.918c-2.248-1.139-3.81-4.323-3.921-7.992l-4.284-25.61h-7.71v5.644zM100.285 44.347l6.974-21.065a2.745 2.745 0 0 1 .867-1.965l2.842-2.268v-5.644h-7.66l-4.293 25.57c-.121 3.669-1.683 6.783-3.931 7.922l-2.016.947h4.697c1.33 0 2.409-1.481 2.52-3.497z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#589EF4",
    d: "M25.177 7.861h-9.313L4.102 11.41h15.925l5.15-3.548zM89.238 7.861h9.968l11.773 3.548h-16.58l-5.16-3.548z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B5FB2",
    d: "M25.177 7.861l-5.16 3.548.07 1.955 5.16-3.86-.07-1.643zM26.628 3.528l-1.451 1.028v2.983l.07 1.955 1.31-1.048.071-4.918zM87.777 3.528l1.461 1.028-.01 2.983-.07 1.955-1.3-1.048-.081-4.918zM89.239 7.861l5.16 3.548-.07 1.955-5.16-3.86.07-1.643z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E85EF",
    d: "M99.206 4.556h-9.968v3.306h9.968V4.556zM25.177 4.556h-9.303v3.306h9.303V4.556z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#589EF4",
    d: "M87.777 3.528h8.093l3.336 1.028h-9.968l-1.461-1.028zM26.629 3.528H19.2l-3.337 1.028h9.313l1.452-1.028z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M19.664 18.918H4.032l2.892 2.248c.227.148.403.363.504.614h13.153l-.917-2.862zM94.741 18.918l-.917 2.863h13.828c.138-.217.3-.416.484-.595l2.842-2.268H94.741zM18.515 15.36a.132.132 0 0 1 0-.06c.14-.476.43-.893.826-1.19l.746-.716H4.102v3.336h14.856l-.443-1.37zM94.258 13.364l.746.716c.391.312.677.738.816 1.22a.132.132 0 0 0 0 .06l-.444 1.37h15.592v-3.366h-16.71z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#589EF4",
    d: "M90.176 31.618H24.612v.836h65.564v-.836zM24.19 32.454a49.89 49.89 0 0 1-.636-1.068 40.908 40.908 0 0 1-5.039-15.038V15.34l4.465 13.95 1.21 3.164z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M92.151 35.85H22.627l1.986-3.396h65.553l1.985 3.397z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#589EF4",
    d: "M90.166 32.454c.221-.343.433-.705.645-1.068a41.072 41.072 0 0 0 5.04-15.038V15.34L91.384 29.3l-1.22 3.154z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: 115,
    height: 55.958,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 57.389,
    x2: 57.389,
    y1: 35.851,
    y2: 32.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h106.1v47.52H0z",
    transform: "translate(4.032) scale(1.00789)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashFull);
export default __webpack_public_path__ + "static/media/trash-full.17206326f74c82e35ee118c09e97ac0e.svg";
export { ForwardRef as ReactComponent };